export enum DiscountEnumDTO {
    Amount = "Amount",
    Percentage = "Percentage"
}
